(() => {
  if (customElements.get('cards-slider')) {
    return;
  }

  class CardsSlider extends customElements.get('slider-component') {
    constructor() {
      super();

      // 데이터 속성(없으면 기본값 4x2)으로 모바일 행/열 제어
      const mobileItems = Number(this.dataset.mobileItems || 4); // 가로 4
      const mobileRows  = Number(this.dataset.mobileRows  || 2); // 세로 2

      this.options = {
        ...this.options,
        ...{
          spaceBetween: this.hasAttribute('data-gap')
            ? Number(this.getAttribute('data-gap'))
            : 16,
          // 기본(아주 작은 폭)에서는 1장, grid 없음
          slidesPerView: 1,

          // 중요: 반응형 구간마다 grid를 명시
          breakpoints: {
            // 0 ~ 749px: 모바일 - 4열 × 2행
            0: {
              slidesPerView: mobileItems,        // 4
              grid: { rows: mobileRows, fill: 'row' }, // 2행
              spaceBetween: 8
            },
            // 750 ~ 989px: 태블릿 - 2열, 1행
            750: {
              slidesPerView: 2,
              grid: { rows: 1 },
              spaceBetween: 12
            },
            // 990px+ : 데스크톱 - 섹션 설정값, 1행
            990: {
              speed: 1000,
              slidesPerView: Number(this.dataset.itemsPerSlide),
              grid: { rows: 1 },
              spaceBetween: 16
            }
          }
        }
      };
    }
  }

  customElements.define('cards-slider', CardsSlider);
})();

